import { render, staticRenderFns } from "./TableManager.vue?vue&type=template&id=70f34d4a&scoped=true"
import script from "./TableManager.vue?vue&type=script&lang=js"
export * from "./TableManager.vue?vue&type=script&lang=js"
import style0 from "./TableManager.vue?vue&type=style&index=0&id=70f34d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f34d4a",
  null
  
)

export default component.exports